/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */


/*@ngInject*/
export default function ActivationLinkDialogController($mdDialog, $translate, toast, activationLink) {

    var vm = this;

    vm.$onInit = function () {
        vm.activationLink = activationLink;

        vm.onActivationLinkCopied = onActivationLinkCopied;
        vm.close = close;
    };

    function onActivationLinkCopied(){
        toast.showSuccess($translate.instant('user.activation-link-copied-message'), 750, angular.element('#activation-link-dialog-content'), 'bottom left');
    }

    function close() {
        $mdDialog.hide();
    }

}


// WEBPACK FOOTER //
// ./src/app/user/activation-link.controller.js